
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';
import {initAuth} from "@platform/platform-auth";

const authConfiguration = {
    "clientId": process.env.REACT_APP_CLIENT_ID,
    "redirectUri": 'https://local.cj.com:3000/oauth-callback',
}

const root = ReactDOM.createRoot(document.getElementById('root'));
initAuth(authConfiguration).then(() => root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
